import(/* webpackMode: "eager" */ "/app/src/ui/wrappers/GlobalWrapper/GlobalWrapper.tsx");
